export enum BaseModalPresetEnum {
  primary = 'primary',
  secondary = 'secondary',
  notifying = 'notifying',
  custom = 'custom'
}

export type BaseModalPresetType = BaseModalPresetEnum.primary
  | BaseModalPresetEnum.secondary
  | BaseModalPresetEnum.notifying
  | BaseModalPresetEnum.custom

export enum BaseModalPositionEnum {
  center = 'center',
  left = 'left',
  top = 'top',
  right = 'right',
  bottom = 'bottom',
  custom = 'custom'
}

export type BaseModalPositionType = BaseModalPositionEnum.center
  | BaseModalPositionEnum.left
  | BaseModalPositionEnum.top
  | BaseModalPositionEnum.right
  | BaseModalPositionEnum.bottom
  | BaseModalPositionEnum.custom

export type BaseModalCustomPositionType = {
  top?: string;
  right?: string;
  bottom?: string;
  left?: string;
}
